import type { ApprovalContext } from './types';

export const APPROVAL_ADMIN_ROOT = '/app/nastaveni/schvalovaci-proces';
export const APPROVAL_DATA_ROOT = '/app/data/schvalovani';
export const APPROVAL_ROUTES = {
  settings: `${APPROVAL_ADMIN_ROOT}/schvalovani-nastaveni`,
  approvers: `${APPROVAL_ADMIN_ROOT}/schvalovatele`,
  exemptions: `${APPROVAL_ADMIN_ROOT}/schvalovani-vyjimky`,
  queue: `${APPROVAL_DATA_ROOT}/fronta-zadosti`,
  mine: `${APPROVAL_DATA_ROOT}/moje-polozky`,
} as const;

export const APPROVAL_REDIRECTS: Record<string, string> = {
  [APPROVAL_ADMIN_ROOT]: APPROVAL_ROUTES.settings,
  [APPROVAL_DATA_ROOT]: APPROVAL_ROUTES.queue,
  '/app/nastaveni/sprava-firmy/schvalovani': APPROVAL_ROUTES.settings,
  '/app/schvalovani/moje': APPROVAL_ROUTES.mine,
  '/app/schvalovani': APPROVAL_ROUTES.queue,
};

export const menuRoute = (item: any): string =>
  [item.route_1, item.route_2, item.route_3, item.route_4].filter(Boolean).join('');

export const menuLevel = (menu: any, level: number): any[] =>
  menu?.[`menu_${level}`] ?? menu?.[`menu${level}`] ?? [];

export const hasApprovalAdminAccess = (
  menu: any,
  route: string = APPROVAL_ROUTES.settings
): boolean => menuLevel(menu, 3).some((item) => menuRoute(item) === route && item.status === 2);

/**
 * Zobrazení položek Data › Schvalování podle /approvals/context/:
 * skupina + Moje položky při `enabled`, Fronta žádostí navíc jen pro
 * admina nebo schvalovatele. Bez kontextu (načítá se / chyba) se větev skrývá.
 */
export const isVisibleApprovalMenuItem = (item: any, context?: ApprovalContext): boolean => {
  const route = menuRoute(item);
  if (!(route === APPROVAL_DATA_ROOT || route.startsWith(`${APPROVAL_DATA_ROOT}/`))) return true;
  if (!context?.enabled) return false;
  if (route === APPROVAL_ROUTES.queue) return context.is_admin || context.is_approver;
  return true;
};
